module.exports = __webpack_public_path__ + "img/shop10.b6d3053b.jpg";